import React from 'react';
import { AuthPage } from '@repo/auth';
import { useTranslation } from 'react-i18next';
import loginHero from '../assets/loginhero.jpg';

const LoginPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <AuthPage
      portalName={t('student.auth.portalName', 'Student Portal')}
      heroImage={loginHero}
      heroTitle1={t('student.auth.heroTitle1', 'Track your')}
      heroTitle2={t('student.auth.heroTitle2', 'learning journey')}
      heroSubtitle={t(
        'student.auth.heroSubtitle',
        'Access your courses, sessions, attendance, and payments in one place.'
      )}
    />
  );
};

export default LoginPage;
